import { createFileRoute } from '@tanstack/react-router';

import { OptInForm } from '@/features/opt-in';

export const Route = createFileRoute('/opt-in/$organizationSlug/')({
  component: OptInPage,
});

function OptInPage() {
  const { organizationSlug } = Route.useParams();

  return (
    <>
      <title>Text updates | Borrah</title>
      <OptInForm organizationSlug={organizationSlug} />
    </>
  );
}
